import { styled } from 'styled-components'

export const TextCell = styled.div`
  color: var(--text-11);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  &[data-trend='up'] {
    color: var(--up-9);
  }
  &[data-trend='down'] {
    color: var(--down-9);
  }
`

export const EmptyCell = () => <EmptyCellRoot>—</EmptyCellRoot>

const EmptyCellRoot = styled(TextCell)`
  color: var(--text-9);
`
